{{#if config.label}}
  {{> elements/_page_builder_label label=config.label description=config.description}}
{{/if}}
<div class="tool-field">
  <textarea name="textarea" placeholder="{{ config.placeholder }}">{{ context }}</textarea>
</div>
